export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10190.3e62e4e9.jpg";